import { LOCALE_TO_ONETRUST_RESOURCE_MAP } from "@/shared/constants";

import { Locale } from "@/types/locale";

export const ONETRUST_ALERT_BOX_COOKIE_NAME = "OptanonAlertBoxClosed";
export const ONETRUST_CONSENT_COOKIE_NAME = "OptanonConsent";
export const ONETRUST_COOKIE_DOMAIN = ".clearpay.co.uk";
export const ONETRUST_FOOTER_CTA_NAME = "Onetrust";
export const ONETRUST_READY_EVENT_NAME = "onetrust:sdk-ready";

type OneTrustGlobal = {
    LoadBanner?: () => void;
    ToggleInfoDisplay?: () => void;
};

const getOneTrust = (): OneTrustGlobal | undefined =>
    typeof window === "undefined"
        ? undefined
        : (window as Window & { OneTrust?: OneTrustGlobal }).OneTrust;

export const hasOnetrustSdkForLocale = (locale?: Locale): boolean =>
    Boolean(locale && LOCALE_TO_ONETRUST_RESOURCE_MAP[locale]?.id);

export const hasLoadedOnetrustSdk = (): boolean =>
    typeof getOneTrust()?.ToggleInfoDisplay === "function";

// Locale-specific OneTrust footer CTA text
export const getOnetrustFooterCtaText = (locale?: string): string => {
    if (locale === "en-US") {
        return "Your Privacy Choices";
    }
    return "Cookie preferences";
};

export const deleteCookie = (name: string, domain = "", path = "/") => {
    if (typeof document !== "undefined") {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=${domain}; path=${path}`;
    }
};

export const hasCookie = (name: string) => {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length == 2) {
        return true;
    }
};

export const reloadOTBanner = () => {
    if (!hasCookie("OptanonAlertBoxClosed")) {
        const otConsentSdk = document.getElementById("onetrust-consent-sdk");

        if (otConsentSdk) {
            otConsentSdk.remove();
        }

        getOneTrust()?.LoadBanner?.();
    }
};

export const reloadOTPreferenceCenter = () => {
    const toggleInfoDisplay = getOneTrust()?.ToggleInfoDisplay;

    if (typeof toggleInfoDisplay !== "function") {
        return false;
    }

    toggleInfoDisplay();
    return true;
};

export const getCookie = (name: string) => {
    const cookieValue = document.cookie.split("; ").find((row) => row.startsWith(name + "="));
    return cookieValue ? cookieValue.split("=")[1] : "";
};
